import { useMatch } from 'react-router-dom';
import { FormikDrawer } from 'shared/form/FormikDrawer';
import { SuperPayBankAccountDTO } from 'shared/modules/superpay/SuperPayDTO';
import { SUPERPAY_PROFILE_ROUTES } from '../SuperPayRoute';
import { BankVerificationContentDrawer } from './BankVerificationContentDrawer';

interface VerifyBankAccountDrawerProps {
  bankAccount?: SuperPayBankAccountDTO;
  onClose: () => void;
  onComplete: () => void;
}

export function BankVerificationDrawer({
  bankAccount,
  onClose,
  onComplete,
}: VerifyBankAccountDrawerProps) {
  const superPayProfileMatch = useMatch(
    SUPERPAY_PROFILE_ROUTES.bankVerification,
  );

  return (
    <FormikDrawer open={!!superPayProfileMatch} onClose={onClose}>
      <BankVerificationContentDrawer
        bankAccountDetails={bankAccount}
        onClose={onClose}
        onComplete={() => {
          onClose();
          onComplete();
        }}
      />
    </FormikDrawer>
  );
}
